<template>
	<div class="sms-shipping">
		<div>Gavekortet sendes via SMS direkte til mottaker. Du kan selv velge dato og klokkeslett for når du ønsker den skal sendes.</div>
		<v-form v-model="valid">
			<section>
				<v-row>
					<v-col cols="4" sm="3">
						<img class="image-fluid" :src="getSMSImageFromStore" />
					</v-col>
					<v-col cols="8" sm="9">
						<v-row>
							<v-col cols="12">
								<v-text-field
									v-model="giftcard.deliveryPhoneNumber"
									label="Telefonnummer"
									class="prime"
									placeholder=" "
									v-mask="'########'"
									type="tel"
									required
									prefix="+47"
									:rules="rules.deliveryPhoneNumber"
								/>
							</v-col>

							<v-col cols="12">
								<v-datetime-picker
									ref="dateTimePicker"
									label="Leveringstidpunkt"
									v-model="deliverySMSSendTimeModel"
									:time-picker-props="timeProps"
									:date-picker-props="datePickerProps"
									:text-field-props="{ class: 'prime delivery-sms-send-time' }"
									dateFormat="dd.MM.yyyy"
								>
									<template v-slot:actions>
										<div class="sms-sending-time-actions">
											<v-btn text small class="text-uppercase" color="primary" @click="dateTimePickerSendNow()">Send nå</v-btn>
											<v-btn text small class="text-uppercase" color="primary" @click="dateTimePickerCancel()">Lukk</v-btn>
											<v-btn text small class="text-uppercase" color="primary" @click="dateTimePickerOk()">Ok</v-btn>
										</div>
									</template>
								</v-datetime-picker>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</section>
		</v-form>
	</div>
</template>

<script>
import { GiftCardPurchaseDetails } from '@/services/models';
// import { isEqual } from 'lodash-es';
import moment from 'moment';
export default {
	name: 'sms-shipping',
	components: {},
	model: {
		prop: 'giftcard'
	},
	props: {
		giftcard: GiftCardPurchaseDetails
	},
	data() {
		return {
			rules: {
				deliveryEmail: [v => /.+@.+/.test(v) || 'Ugyldig epost adresse'],
				deliveryPhoneNumber: [v => v.length == 8 || 'Telefonnummeret må være 8 tegn']
			},
			valid: false,
			datePickerProps: {
				color: 'primary',
				class: 'delivery-sms-datetime-picker',
				locale: 'no',
				min: new Date().toISOString(),
				'day-format'(isoDateString) {
					return moment(isoDateString).format('D');
				},
				'weekday-format'(isoDateString) {
					return moment(isoDateString).format('ddd');
				},
				'title-date-format'(isoDateString) {
					return moment(isoDateString).format('dddd DD. MMM');
				}
			}
		};
	},
	methods: {
		resetInput: function() {
			this.giftcard.deliveryEmail = '';
			this.giftcard.deliveryPhoneNumber = '';
			this.giftcard.deliverySMSTime = moment(new Date());
		},

		dateTimePickerOk() {
			this.$refs.dateTimePicker.okHandler();
		},
		dateTimePickerCancel() {
			this.$refs.dateTimePicker.resetPicker();
		},
		dateTimePickerSendNow() {
			this.deliverySMSSendTimeModel = new Date();
			this.$refs.dateTimePicker.resetPicker();
		}
	},
	computed: {
		timeProps() {
			return {
				format: '24hr',
				color: 'primary'
			};
		},
		deliverySMSSendTimeModel: {
			get() {
				if (!this.giftcard.deliverySMSTime) return null;
				return this.$moment(this.giftcard.deliverySMSTime).format('DD.MM.YYYY HH:mm');
			},
			set(value) {
				this.giftcard.deliverySMSTime = this.$moment(value);
			}
		},
		getSMSImageFromStore() {
			return this.$store.state.giftcard.deliveryOptions.find(x => x.deliveryMethod == '1').portraitImageUrl || '';
		}
	},
	watch: {
		valid: function(value) {
			this.$emit('onValidationChange', value);
		}
	}
};
</script>

<style lang="scss">
.sms-shipping {
	.delivery-sms-send-time {
		.v-text-field__slot > input {
			background-color: var(--v-secondary-lighten1) !important;
		}
		&.v-text-field > .v-input__control > .v-input__slot::before {
			border-color: var(--v-primary-base) !important;
		}
	}
}
.delivery-sms-datetime-picker {
	.v-btn {
		padding: 0 !important;
	}
}

.sms-sending-time-actions {
	.v-btn {
		padding: 0 24px !important;
		min-width: 40px !important;
	}
}
</style>

<style lang="scss" scoped>
.image-fluid {
	max-width: 100%;
	height: auto;
}
</style>
